import { QueryClient as TQueryClient, QueryClientProvider as TQueryClientProvider } from '@tanstack/react-query'
import type { PropsWithChildren } from 'react'
import { WagmiProvider } from 'wagmi'

import ConnectWalletModal from '../../components/WalletModal'
import { wagmiConfig } from '../wagmi'
import { configureWallets, Web3ModalProvider } from '../wallet-connect'

const wallets = configureWallets({
  walletconnectProjectId: process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID as string,
})

const tQueryClient = new TQueryClient()

export const WalletProvider = ({ children }: PropsWithChildren) => {
  return (
    <WagmiProvider config={wagmiConfig} reconnectOnMount={false}>
      <TQueryClientProvider client={tQueryClient}>
        <Web3ModalProvider chains={wagmiConfig.chains} wallets={wallets}>
          <ConnectWalletModal wallets={wallets} />
          {children}
        </Web3ModalProvider>
      </TQueryClientProvider>
    </WagmiProvider>
  )
}
